import { render, staticRenderFns } from "./TemplateDetailsTesting.vue?vue&type=template&id=e528687c&scoped=true&"
import script from "./TemplateDetailsTesting.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsTesting.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailsTesting.vue?vue&type=style&index=0&id=e528687c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e528687c",
  null
  
)

export default component.exports